<template >
  <v-col class="py-0">
    <v-row v-if="label">
      <b>{{ this.label }}</b>
    </v-row>
    <v-row v-if="text">
      <p
        :class="['mb-0 v-input--description', {
          'v-input--description--next': isDescriptionLabel()
        }]"
        full-width
        v-html="processedText"
        @click="handleLinkClick"
      ></p>
    </v-row>

    <v-row v-for="(link, index) in links" :key="index" v-show="visibleIndex === index">
      <v-col>
        <div class="container__media">
          <!-- X para cerrar -->
          <div class="close-button" @click="closeLink">×</div>

          <template v-if="link.type === 'image'">
            <img class="media_link" :src="link.href" alt="Contenido" />
          </template>
          <template v-else-if="link.type === 'video'">
            <iframe
              ref="videoIframe"
              class="media_link"
              :src="link.href"
              frameborder="0"
              allowfullscreen
              controlslist="nodownload"
              @contextmenu.prevent
            ></iframe>
          </template>
        </div>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  props: {
    label: String,
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      links: [],
      visibleIndex: null,
      processedText: '',
    };
  },
  computed: {
    text() {
      const { text } = this.params;
      if (typeof text === 'function') {
        return text();
      }
      return text;
    },
  },
  mounted() {
    this.prepareDynamicLinks();
  },
  methods: {
    isDescriptionLabel() {
      const { aslabel } = this.params;
      return aslabel === 'true';
    },
    prepareDynamicLinks() {
      const parser = new DOMParser();
      const doc = parser.parseFromString(this.text || '', 'text/html');
      const anchorTags = doc.querySelectorAll('a');

      this.links = [];

      anchorTags.forEach((a, index) => {
        const href = a.getAttribute('href');
        const type = a.getAttribute('data-type') || 'image';

        this.links.push({ href, type });

        a.setAttribute('href', '#');
        a.setAttribute('data-index', index);
        a.removeAttribute('target');
        // eslint-disable-next-line no-param-reassign
        a.rel = 'noopener noreferrer';
      });

      this.processedText = doc.body.innerHTML;
    },
    handleLinkClick(event) {
      const { target } = event;
      if (
        target
        && target.tagName === 'A'
        && target.dataset.index !== undefined
      ) {
        event.preventDefault();

        this.visibleIndex = Number(target.dataset.index);

        if (target.dataset.type === 'image') {
          this.pauseVideo();
        }
      }
    },
    closeLink() {
      this.visibleIndex = null;
      this.pauseVideo();
    },
    pauseVideo() {
      let iframe = this.$refs.videoIframe;
      // eslint-disable-next-line prefer-destructuring
      if (Array.isArray(iframe)) iframe = iframe[0];

      if (!iframe) return;

      const currentSrc = iframe.src;
      iframe.src = '';
      this.$nextTick(() => {
        iframe.src = currentSrc;
      });
    },
  },
};
</script>

<style lang="scss">
  .mb {
    margin-bottom: 1rem;
  }

  .v-application .v-input--description {
    > p {
      margin-bottom: 0;
    }

    &.v-input--description--next > p {
      margin: 20px 0 -10px 0;
    }
  }

  .container__media {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
  }

  .container__media iframe,
  .container__media .media_link {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
}

  @media (min-width: 900px) {
    .container__media {
      width: 40rem;
      padding-bottom: calc(40rem * 9 / 16);
    }
  }
</style>
